export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_q01_b.606a6b25.png";